export default __webpack_public_path__ + "media/images/paylogos/gray/mastercard_secure-38739741644b510423457fb347d54181.png";